import React, { Component } from 'react';
import axiosInstance from '../config/axiosConfig';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';

import { getUser } from '../actions/session';
import CustomLoader from '../components/common/loader';
import CustomModal from '../components/common/modal';
import PaymentAdd from './paymentAdd';
import { CLIENT_ID, USER_Balance_LOGS_URL, GET_TOPOFF_PAYMENT, CREATE_TOPOFF_PAYMENT } from '../config/rest_endpoints';
import Pagination from 'react-js-pagination';
import { MAKE_PAYMENT_METHOD } from '../components/routers/RouteConstants';
import { Notifications } from '../components/common/notification';
import StripePayment from './stripePayment';
import { Link, withRouter } from 'react-router-dom';

var firstDate = new Date();
const startT = moment(firstDate.getTime()).subtract(20, 'hours');

export class CdrBalanceTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      User: getUser(),
      tableData: [],
      searchValue: '',
      startDate: startT._d,
      endDate: new Date(),
      isGetting: false,
      selectedtype: 'all',
      isAddModal: false,
      callTypes: [
        { value: 'all', label: 'All' },
        { value: 'successful', label: 'Successful' },
        { value: 'failed', label: 'Failed' }
      ],
      activePage: 1,
      itemsCount: 10,
      totalCount: 0,
      isStripeOpen: false,
      clientId: '',
      isTopoffChecked: true,
      amountCharged: 0,
      minimumCharged: 0,
      isSubmitTopoff: false
    };
    this.handleCallType = this.handleCallType.bind(this);
    this.handleDate = this.handleDate.bind(this);
    this.searchSpace = this.searchSpace.bind(this);
    this.getCdrBalance = this.getCdrBalance.bind(this);
    this.closeAddModal = this.closeAddModal.bind(this);
    this.openAddModal = this.openAddModal.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.closeStripeModal = this.closeStripeModal.bind(this);
    this.openStripeModal = this.openStripeModal.bind(this);
    this.gotoPaymentConfiguration = this.gotoPaymentConfiguration.bind(this);
    this.handleTopoff = this.handleTopoff.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.createTopoffValue = this.createTopoffValue.bind(this);
  }

  componentWillMount() {
    this.getTopoffValue();
  }

  componentDidMount() {
    this.getCdrBalance();
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleTopoff() {
    this.setState({
      isTopoffChecked: !this.state.isTopoffChecked
    });
  }

  closeAddModal() {
    this.setState({
      isAddModal: false
    });
  }

  openAddModal() {
    this.setState({
      isAddModal: true
    });
  }

  closeStripeModal() {
    this.setState({
      isStripeOpen: false
    });
  }

  openStripeModal() {
    this.setState({
      isStripeOpen: true
    });
  }

  handlePageChange(pageNumber) {
    this.setState(
      {
        activePage: pageNumber
      },
      () => {
        this.getCdrBalance();
      }
    );
  }

  handleCallType(selectedtype) {
    this.setState({ selectedtype }, () => {});
  }

  searchSpace(e) {
    this.setState({ searchValue: e.target.value });
  }

  handleDate(date, value) {
    if (value == 'start') {
      this.setState({ startDate: date }, () => {});
    } else {
      this.setState({ endDate: date }, () => {});
    }
  }

  getTopoffValue() {
    let User = getUser();
    if (!User || !User.id) return;
    const payload = { accountID: User.id };
    // Using axiosInstance which automatically adds auth header and handles 401 errors
    axiosInstance.post(`${GET_TOPOFF_PAYMENT}`, payload)
      .then((res) => {
        if (res) {
          let resp = res.data.data;
          console.log('get topoff resp :>> ', resp);
          this.setState({
            amountCharged: resp.amountToCharge,
            minimumCharged: resp.minimumBalance,
            isTopoffChecked: resp.autoTopOff
          });
        }
      })
      .catch((err) => {
        // 401/JWT expiry is handled by axiosInstance interceptor
        if (err.response && err.response.status !== 401) {
          const alert = err.response;
          if (alert.data && alert.data.message !== 'invalid or expired jwt') {
            Notifications.notify(alert.data.message, 'Failed', 'error');
          }
        }
      });
  }

  createTopoffValue(value) {
    const { minimumCharged, amountCharged } = this.state;
    let User = getUser();
    if (!User || !User.id) return;
    this.setState({ isSubmitTopoff: true });
    if (value === 'disable') {
      let payload = { accountID: User.id, autoTopOff: false, minimumBalance: parseFloat(minimumCharged), amountToCharge: parseFloat(amountCharged) };
      console.log('payload :>> ', payload);
      // Using axiosInstance which automatically adds auth header and handles 401 errors
      axiosInstance.post(`${CREATE_TOPOFF_PAYMENT}`, payload)
        .then((res) => {
          if (res) {
            let resp = res.data;
            console.log('res :>> ', res);
            this.setState({ isSubmitTopoff: false });
            Notifications.notify(resp.message, 'Success', 'success');
          }
        })
        .catch((err) => {
          this.setState({ isSubmitTopoff: false });
          if (err.response && err.response.status !== 401) {
            const alert = err.response;
            if (alert.data && alert.data.message !== 'invalid or expired jwt') {
              Notifications.notify(alert.data.message, 'Failed', 'error');
            }
          }
        });
    } else {
      let payload = {
        accountID: User.id,
        autoTopOff: this.state.isTopoffChecked,
        minimumBalance: parseFloat(minimumCharged),
        amountToCharge: parseFloat(amountCharged)
      };
      console.log('payload :>> ', payload);
      axiosInstance.post(`${CREATE_TOPOFF_PAYMENT}`, payload)
        .then((res) => {
          if (res) {
            let resp = res.data;
            console.log('res :>> ', res);
            this.setState({ isSubmitTopoff: false });
            Notifications.notify(resp.message, 'Success', 'success');
          }
        })
        .catch((err) => {
          this.setState({ isSubmitTopoff: false });
          if (err.response && err.response.status !== 401) {
            const alert = err.response;
            if (alert.data && alert.data.message !== 'invalid or expired jwt') {
              Notifications.notify(alert.data.message, 'Failed', 'error');
            }
          }
        });
    }
  }

  gotoPaymentConfiguration() {
    let User = getUser();
    if (!User || !User.id) return;
    console.log('User :>> ', User);
    const payload = { accountID: User.id };
    // Using axiosInstance which automatically adds auth header and handles 401 errors
    axiosInstance.post(`${CLIENT_ID}`, payload)
      .then((res) => {
        if (res) {
          let resp = res.data.data;
          this.props.history.push(`${MAKE_PAYMENT_METHOD}/${resp}`);
        }
      })
      .catch((err) => {
        if (err.response && err.response.status !== 401) {
          const alert = err.response;
          if (alert.data && alert.data.message !== 'invalid or expired jwt') {
            Notifications.notify(alert.data.message, 'Failed', 'error');
          }
        }
      });
  }

  getCdrBalance() {
    const { User, startDate, endDate, activePage, itemsCount } = this.state;
    if (!User || !User.id) return;
    var userId = User.id;
    var payLoad = {
        startDate: moment(startDate).utc().format('YYYY-MM-DDTHH:mm:ss'),
        endDate: moment(endDate).utc().format('YYYY-MM-DDTHH:mm:ss'),
    };
    console.log(`payLoad`, payLoad);
    this.setState({ isGetting: true });
    // Using axiosInstance which automatically adds auth header and handles 401 errors
    axiosInstance.post(`${USER_Balance_LOGS_URL}/${userId}/billing/reports/balance?page=${activePage}&limit=${itemsCount}`, payLoad)
      .then((res) => {
        if (res) {
          console.log(`res`, res);
          this.setState({
            tableData: res.data.data,
            isGetting: false,
            totalCount: res.data.pageinfo.totalCount
          });
        }
      })
      .catch((err) => {
        this.setState({ isGetting: false });
        // 401/JWT expiry is handled by axiosInstance interceptor
        if (err.response && err.response.status !== 401) {
          const alert = err.response;
          if (alert.data && alert.data.message !== 'invalid or expired jwt') {
            Notifications.notify(alert.data.message, 'Failed', 'error');
          }
        }
      });
  }

  renderCdrBalance() {
    const { tableData } = this.state;

    if (tableData === null || tableData.length === 0) {
      return (
        <tr>
          <td colSpan="4">
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '3rem 1rem',
                color: 'var(--color-text-tertiary)'
              }}
            >
              <div
                style={{
                  width: 64,
                  height: 64,
                  borderRadius: '16px',
                  background: 'var(--color-bg-subtle)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '1rem'
                }}
              >
                <i className="icon-wallet" style={{ fontSize: '1.5rem', opacity: 0.5 }}></i>
              </div>
              <p style={{ margin: 0, fontWeight: 500 }}>No balance records found</p>
              <p style={{ margin: '0.25rem 0 0', fontSize: '0.8125rem' }}>Try adjusting your date filters</p>
            </div>
          </td>
        </tr>
      );
    }

    return tableData.map((row, idx) => {
      const isCredit = row.type?.toLowerCase().includes('credit') || row.amount > 0;
      return (
        <tr key={idx}>
          <td>{row.setuptime}</td>
          <td>
            <span
              style={{
                padding: '0.25rem 0.625rem',
                borderRadius: '6px',
                fontSize: '0.75rem',
                fontWeight: 600,
                background: isCredit ? 'rgba(16, 185, 129, 0.1)' : 'rgba(239, 68, 68, 0.1)',
                color: isCredit ? '#10B981' : '#EF4444'
              }}
            >
              {row.type}
            </span>
          </td>
          <td style={{ fontWeight: 500 }}>{row.method}</td>
          <td style={{ fontWeight: 600, color: isCredit ? '#10B981' : '#EF4444' }}>
            {isCredit ? '+' : '-'}${Math.abs(row.amount || 0).toFixed(2)}
          </td>
        </tr>
      );
    });
  }

  render() {
    const { startDate, endDate, isGetting, isAddModal, activePage, itemsCount, totalCount, isStripeOpen, isTopoffChecked, amountCharged, minimumCharged, isSubmitTopoff } =
      this.state;

    let addServer = {
      details: {
        info: 'Paypal Payment',
        msg: <PaymentAdd close={this.closeAddModal} />
      },
      confirmBtn: { label: 'Update', action: '' },
      crossBtn: { action: this.closeAddModal },
      cancelBtn: { label: 'Cancel', action: this.closeAddModal }
    };

    let addStripe = {
      details: {
        info: 'Stripe Payment',
        msg: <StripePayment close={this.closeStripeModal} />
      },
      confirmBtn: { label: 'Update', action: '' },
      crossBtn: { action: this.closeStripeModal },
      cancelBtn: { label: 'Cancel', action: this.closeStripeModal }
    };

    return (
      <div>
        <CustomModal visibility={isAddModal} customBodyCSS={'h20'} modalType={'success'} details={addServer.details} showBtns={false} cancelBtn={addServer.cancelBtn} crossBtn={addServer.crossBtn} />
        <CustomModal visibility={isStripeOpen} customBodyCSS={'h20'} modalType={'success'} details={addStripe.details} showBtns={false} cancelBtn={addStripe.cancelBtn} crossBtn={addStripe.crossBtn} />

        <div style={{ animation: 'fadeInUp 0.5s ease' }}>
          <div className="card" style={{ borderRadius: '20px', overflow: 'hidden' }}>
            {/* Payment Actions Header */}
            <div
              style={{
                padding: '1.25rem 1.5rem',
                background: 'var(--color-bg-subtle)',
                borderBottom: '1px solid var(--color-border)',
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '1rem'
              }}
            >
              {/* Auto Top-off Toggle */}
              <label
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.75rem',
                  cursor: 'pointer'
                }}
              >
                <div
                  onClick={this.handleTopoff}
                  style={{
                    width: 44,
                    height: 24,
                    borderRadius: 12,
                    background: isTopoffChecked ? 'linear-gradient(135deg, #10B981 0%, #059669 100%)' : 'var(--color-border)',
                    position: 'relative',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer'
                  }}
                >
                  <div
                    style={{
                      width: 20,
                      height: 20,
                      borderRadius: '50%',
                      background: 'white',
                      position: 'absolute',
                      top: 2,
                      left: isTopoffChecked ? 22 : 2,
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                      transition: 'left 0.3s ease'
                    }}
                  />
                </div>
                <span style={{ fontWeight: 600, color: 'var(--color-text)' }}>{isTopoffChecked ? 'Auto Top-off Enabled' : 'Auto Top-off Disabled'}</span>
              </label>

              {/* Payment Buttons */}
              <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                <button
                  onClick={this.openStripeModal}
                  style={{
                    background: 'linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)',
                    border: 'none',
                    borderRadius: '10px',
                    padding: '0.5rem 1rem',
                    color: 'white',
                    fontWeight: 600,
                    fontSize: '0.8125rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    boxShadow: '0 4px 14px rgba(99, 102, 241, 0.3)',
                    cursor: 'pointer'
                  }}
                >
                  <i className="fab fa-stripe"></i>
                  Stripe
                </button>
                <button
                  onClick={this.openAddModal}
                  style={{
                    background: 'linear-gradient(135deg, #0070BA 0%, #003087 100%)',
                    border: 'none',
                    borderRadius: '10px',
                    padding: '0.5rem 1rem',
                    color: 'white',
                    fontWeight: 600,
                    fontSize: '0.8125rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    boxShadow: '0 4px 14px rgba(0, 112, 186, 0.3)',
                    cursor: 'pointer'
                  }}
                >
                  <i className="fab fa-paypal"></i>
                  PayPal
                </button>
                <button
                  onClick={this.gotoPaymentConfiguration}
                  style={{
                    background: 'var(--color-surface)',
                    border: '1px solid var(--color-border)',
                    borderRadius: '10px',
                    padding: '0.5rem 1rem',
                    color: 'var(--color-text)',
                    fontWeight: 600,
                    fontSize: '0.8125rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    cursor: 'pointer'
                  }}
                >
                  <i className="icon-cog3"></i>
                  Configure
                </button>
              </div>
            </div>

            {/* Top-off Settings */}
            <div
              style={{
                padding: '1.25rem 1.5rem',
                background: 'var(--color-surface)',
                borderBottom: '1px solid var(--color-border)'
              }}
            >
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1.5rem', alignItems: 'flex-end' }}>
                <div style={{ flex: '1 1 200px' }}>
                  <label
                    style={{
                      display: 'block',
                      fontSize: '0.75rem',
                      fontWeight: 600,
                      color: 'var(--color-text-secondary)',
                      marginBottom: '0.5rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }}
                  >
                    Amount to Charge
                  </label>
                  <div style={{ position: 'relative' }}>
                    <span
                      style={{
                        position: 'absolute',
                        left: '1rem',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        color: 'var(--color-text-tertiary)',
                        fontWeight: 600
                      }}
                    >
                      $
                    </span>
                    <input
                      type="number"
                      disabled={!isTopoffChecked}
                      name="amountCharged"
                      value={amountCharged}
                      onChange={this.handleChange}
                      style={{
                        width: '100%',
                        padding: '0.625rem 1rem 0.625rem 1.75rem',
                        borderRadius: '10px',
                        border: '1px solid var(--color-border)',
                        background: isTopoffChecked ? 'var(--color-surface)' : 'var(--color-bg-subtle)',
                        color: 'var(--color-text)',
                        fontSize: '0.875rem',
                        opacity: isTopoffChecked ? 1 : 0.6
                      }}
                    />
                  </div>
                  <small style={{ fontSize: '0.6875rem', color: 'var(--color-text-tertiary)', marginTop: '0.25rem', display: 'block' }}>
                    Amount to charge when balance is low
                  </small>
                </div>

                <div style={{ flex: '1 1 200px' }}>
                  <label
                    style={{
                      display: 'block',
                      fontSize: '0.75rem',
                      fontWeight: 600,
                      color: 'var(--color-text-secondary)',
                      marginBottom: '0.5rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }}
                  >
                    Minimum Balance
                  </label>
                  <div style={{ position: 'relative' }}>
                    <span
                      style={{
                        position: 'absolute',
                        left: '1rem',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        color: 'var(--color-text-tertiary)',
                        fontWeight: 600
                      }}
                    >
                      $
                    </span>
                    <input
                      type="number"
                      disabled={!isTopoffChecked}
                      name="minimumCharged"
                      value={minimumCharged}
                      onChange={this.handleChange}
                      style={{
                        width: '100%',
                        padding: '0.625rem 1rem 0.625rem 1.75rem',
                        borderRadius: '10px',
                        border: '1px solid var(--color-border)',
                        background: isTopoffChecked ? 'var(--color-surface)' : 'var(--color-bg-subtle)',
                        color: 'var(--color-text)',
                        fontSize: '0.875rem',
                        opacity: isTopoffChecked ? 1 : 0.6
                      }}
                    />
                  </div>
                  <small style={{ fontSize: '0.6875rem', color: 'var(--color-text-tertiary)', marginTop: '0.25rem', display: 'block' }}>
                    Trigger top-off when balance falls below this
                  </small>
                </div>

                <button
                  onClick={isTopoffChecked ? this.createTopoffValue : this.createTopoffValue.bind(this, 'disable')}
                  disabled={isSubmitTopoff}
                  style={{
                    background: isTopoffChecked ? 'linear-gradient(135deg, #10B981 0%, #059669 100%)' : 'var(--color-bg-subtle)',
                    border: 'none',
                    borderRadius: '10px',
                    padding: '0.625rem 1.25rem',
                    color: isTopoffChecked ? 'white' : 'var(--color-text)',
                    fontWeight: 600,
                    fontSize: '0.875rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    cursor: isSubmitTopoff ? 'not-allowed' : 'pointer',
                    opacity: isSubmitTopoff ? 0.7 : 1
                  }}
                >
                  {isSubmitTopoff ? <i className="icon-spinner2 spinner"></i> : <i className="icon-checkmark2"></i>}
                  Save Settings
                </button>
              </div>
            </div>

            {/* Date Filters */}
            <div
              style={{
                padding: '1.25rem 1.5rem',
                background: 'var(--color-bg-subtle)',
                borderBottom: '1px solid var(--color-border)'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '1rem',
                  padding: '1rem',
                  background: 'var(--color-surface)',
                  borderRadius: '14px',
                  border: '1px solid var(--color-border)'
                }}
              >
                <div style={{ flex: '1 1 200px' }}>
                  <label
                    style={{
                      display: 'block',
                      fontSize: '0.75rem',
                      fontWeight: 600,
                      color: 'var(--color-text-secondary)',
                      marginBottom: '0.5rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }}
                  >
                    Start Date
                  </label>
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => this.handleDate(date, 'start')}
                    showTimeSelect
                    timeFormat="HH:mm:ss"
                    timeIntervals={15}
                    timeCaption="time"
                    dateFormat="MMMM d, yyyy h:mm:ss aa"
                    className="premium-datepicker"
                    isClearable
                    placeholderText="Select start date"
                  />
                </div>
                <div style={{ flex: '1 1 200px' }}>
                  <label
                    style={{
                      display: 'block',
                      fontSize: '0.75rem',
                      fontWeight: 600,
                      color: 'var(--color-text-secondary)',
                      marginBottom: '0.5rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }}
                  >
                    End Date
                  </label>
                  <DatePicker
                    name="end"
                    selected={endDate}
                    onChange={(date) => this.handleDate(date, 'end')}
                    showTimeSelect
                    timeFormat="HH:mm:ss"
                    timeIntervals={15}
                    timeCaption="time"
                    dateFormat="MMMM d, yyyy h:mm:ss aa"
                    className="premium-datepicker"
                    maxDate={new Date()}
                    isClearable
                    placeholderText="Select end date"
                  />
                </div>
                <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                  <button
                    type="button"
                    onClick={this.getCdrBalance}
                    style={{
                      background: 'linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)',
                      border: 'none',
                      borderRadius: '10px',
                      padding: '0.625rem 1.25rem',
                      color: 'white',
                      fontWeight: 600,
                      fontSize: '0.875rem',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      boxShadow: '0 4px 14px rgba(99, 102, 241, 0.3)',
                      cursor: 'pointer'
                    }}
                  >
                    <i className="icon-search4"></i>
                    Filter
                  </button>
                </div>
              </div>
            </div>

            {/* Table */}
            <div className="table-responsive" style={{ padding: '0' }}>
              <table className="table text-nowrap" style={{ marginBottom: 0 }}>
                <thead>
                  <tr>
                    {['Setup Time', 'Type', 'Method', 'Amount'].map((header) => (
                      <th
                        key={header}
                        style={{
                          background: 'var(--color-surface)',
                          color: 'var(--color-text-secondary)',
                          fontWeight: 600,
                          fontSize: '0.6875rem',
                          textTransform: 'uppercase',
                          letterSpacing: '0.05em',
                          padding: '1rem 1.25rem',
                          borderBottom: '1px solid var(--color-divider)'
                        }}
                      >
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>{isGetting ? <CustomLoader colSpan={4} message="Loading balance records..." /> : this.renderCdrBalance()}</tbody>
              </table>
            </div>

            {/* Pagination Footer */}
            <div
              style={{
                padding: '1rem 1.5rem',
                borderTop: '1px solid var(--color-border)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: '1rem'
              }}
            >
              <div
                style={{
                  fontSize: '0.8125rem',
                  color: 'var(--color-text-secondary)'
                }}
              >
                Showing <strong>{Math.min((activePage - 1) * itemsCount + 1, totalCount)}</strong> to{' '}
                <strong>{Math.min(activePage * itemsCount, totalCount)}</strong> of <strong>{totalCount}</strong> records
              </div>
              <Pagination
                activePage={activePage}
                itemsCountPerPage={itemsCount}
                totalItemsCount={totalCount}
                pageRangeDisplayed={5}
                onChange={this.handlePageChange.bind(this)}
                itemClass="page-item"
                linkClass="page-link"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(CdrBalanceTable);
